import css from './QR.module.scss'
import React, { useEffect } from 'react'
import { useTranslation, withTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { DynamicQRStatus } from 'types/qr'

import { QueryParams, RouteParams, Routes } from 'meta/routes'
import { Dates } from 'utils/dates'

import Head from 'components/common/Head'
import Img from 'components/Media/Img'
import { useQueryParams } from 'hooks/useQueryParams'

const QR: React.FC = () => {
  const { t } = useTranslation()

  const { status } = useParams<RouteParams['QR']>()
  const { availableAt } = useQueryParams<QueryParams['QR']>()

  const navigate = useNavigate()

  useEffect(() => {
    if (!status || ![DynamicQRStatus.notActive, DynamicQRStatus.notFound, DynamicQRStatus.overdue].includes(status)) {
      navigate(Routes.NotFound.generatePath(), { replace: true })
    }
  }, [])

  return (
    <>
      <Head>
        <link href="https://fonts.googleapis.com/css?family=Nunito Sans" rel="stylesheet" />
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <div className={css.wrapper}>
        <div className={css.box}>
          <div className={css.logo}>
            <Img alt="TicketSMS Logo" src="/logo/TicketSms_logo.svg" />
          </div>

          <div className={css.image}>
            {status === DynamicQRStatus.notFound && <Img alt="QR status" src="/qr/notFound.svg" />}
            {status === DynamicQRStatus.notActive && Boolean(availableAt) && (
              <Img alt="QR status" src="/qr/notActive.svg" />
            )}
            {(status === DynamicQRStatus.overdue || (status === DynamicQRStatus.notActive && !availableAt)) && (
              <Img alt="QR status" src="/qr/overdue.svg" />
            )}
          </div>

          {status === DynamicQRStatus.notFound && (
            <div className={css.text}>
              <span className={css.title}>{t('qr:notFound')}</span>
            </div>
          )}

          {status === DynamicQRStatus.notActive && !availableAt && (
            <div className={css.text}>
              <span className={css.title}>{t('qr:notActive')}</span>
              <span className={css.desc}>{t('qr:try_again_later')}</span>
            </div>
          )}

          {status === DynamicQRStatus.notActive && Boolean(availableAt) && (
            <div className={css.text}>
              <span className={css.title}>{t('qr:notActive_yet')}</span>
              {availableAt && (
                <span className={css.desc}>
                  {Dates.format(new Date(Number(availableAt)), t('qr:try_again_datetime'))}
                </span>
              )}
            </div>
          )}

          {status === DynamicQRStatus.overdue && (
            <div className={css.text}>
              <span className={css.title}>{t('qr:overdue')}</span>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

const namespaces = ['qr']

export default withTranslation(namespaces)(QR)
